import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={23}
    height={26}
    viewBox="0 0 23 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2823F4'}
      d="M22.82 21.011c0 2.42-2.03 4.38-4.53 4.38-2.5 0-4.53-1.96-4.53-4.38 0-.51.11-.99.27-1.44l-6.1-3.51a4.57 4.57 0 0 1-3.34 1.44c-2.5 0-4.53-1.96-4.53-4.38s2.03-4.38 4.53-4.38c1.33 0 2.51.56 3.34 1.44l6.1-3.51a4.09 4.09 0 0 1-.27-1.44c0-2.42 2.03-4.38 4.53-4.38 2.5 0 4.53 1.96 4.53 4.38s-2.03 4.38-4.53 4.38a4.57 4.57 0 0 1-3.34-1.44l-6.1 3.51c.17.46.27.93.27 1.44 0 .51-.11.99-.27 1.44l6.1 3.51a4.57 4.57 0 0 1 3.34-1.44c2.5 0 4.53 1.96 4.53 4.38Z"
    />
  </Svg>
);
export default SvgComponent;
